module.exports = {"markup":"<span class=\"inline-market-down inline-icon\"><svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"11\" viewBox=\"0 0 15 11\"><path fill=\"#B51800\" d=\"M15 1.03L13.97 0H1L0 1l7 10h.958L15 1.016z\"/></svg></span>"}


//////////////////
// WEBPACK FOOTER
// ./static/src/inline-svgs/icon/market-down.svg
// module id = 316
// module chunks = 5 15